<template>
  <v-layout>
    <v-flex shrink>
      <v-card
        width="250px"
        class="elevation-5"
        v-if="Object.keys(permission.main_menu).length > 0"
      >
        <v-list class="py-0" style="background-color: #000">
          <v-list-tile>
            <v-list-tile-title
              style="text-align: center; font-size: 20px; color: white"
              >MAIN MENU</v-list-tile-title
            >
          </v-list-tile>
        </v-list>
        <v-list dark class="py-0" style="background-color: #424242">
          <v-list-tile
            v-for="item in filteredSidebar"
            :key="item.title"
            :to="item.link"
          >
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content class="white--text">
              {{ item.title }}
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      menuItems: [
        {
          icon: "directions_bike",
          title: "Rider Tracker",
          permission_name: "tracking_rider",
          link: "/weserve_admin_login/tracking/-/rider-tracker",
        },
        {
          icon: "mdi-domain",
          title: "Hotel Service",
          permission_name: "hotel_service",
          link: "/weserve_admin_login/-/hotel-services/hotel-list",
        },
        {
          icon: "mdi-briefcase-variant",
          title: "Weserve for Business",
          permission_name: "dine_in_management",
          link: "/weserve_admin_login/-/business/table",
        },
        {
          icon: "dining",
          title: "Dine-in Management",
          permission_name: "dine_in_management",
          link: "/weserve_admin_login/-/maindinein",
        },
        {
          icon: "mdi-advertisements",
          title: "WESERVE ADS",
          permission_name: "weserve_ads",
          link: "/weserve_admin_login/weserve-ads",
        },
        {
          icon: "label",
          title: "Promotion",
          permission_name: "promotion_manage",
          link: "/weserve_admin_login/-/promotion-manage",
        },
        {
          icon: "dashboard",
          title: "Report Dashboard",
          permission_name: "report_dashboard",
          link: "/weserve_admin_login/-/reportdashboard/main",
        },
        {
          icon: "store",
          title: "Merchant Management",
          permission_name: "merchant_manage",
          link: "/weserve_admin_login/-/mainmerchant/contactstoreapprove",
        },
        {
          icon: "perm_device_information",
          title: "Find USER OTP",
          permission_name: "find_user_otp",
          link: "/weserve_admin_login/-/find_user_otp",
        },
        {
          icon: "group",
          title: "Customer",
          permission_name: "customer_manage",
          link: "/weserve_admin_login/-/customermanage",
        },
        {
          icon: "person",
          title: "Staff",
          permission_name: "manage_staff",
          link: "/weserve_admin_login/-/usermanage",
        },
        {
          icon: "person",
          title: "Manager Management",
          permission_name: "manager_manage",
          link: "/weserve_admin_login/-/manager-manage",
        },
        {
          icon: "build",
          title: "App Maintenance",
          permission_name: "app_maintance",
          link: "/weserve_admin_login/-/set_maintenance",
        },
        {
          icon: "notifications_active",
          title: "App Notification",
          permission_name: "app_notificaition",
          link: "/weserve_admin_login/-/appnotification",
        },
        {
          icon: "redeem",
          title: "Campaign Reward",
          permission_name: "app_campaign_reward",
          link: "/weserve_admin_login/-/appcampaignreward",
        },
        {
          icon: "redeem",
          title: "Campaign Crypto",
          permission_name: "campaign_crypto",
          link: "/weserve_admin_login/-/campaign-crypto",
        },
        {
          icon: "room_service",
          title: "Service Management",
          permission_name: "service_manage",
          link: "/weserve_admin_login/-/servicemanage",
        },
        {
          icon: "score",
          title: "Point Management",
          permission_name: "point_manage",
          link: "/weserve_admin_login/-/pointmanage",
        },
        {
          icon: "outlined_flag",
          title: "Tier Benefits",
          permission_name: "tier_benefits_manage",
          link: "/weserve_admin_login/-/tierbenefitsmanage",
        },
        {
          icon: "token",
          title: "Transfer Token",
          permission_name: "transfer_token_queue",
          link: "/weserve_admin_login/-/transfer-token-queue",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      selectedMenu: (state) => state.backOffice.selectedMenu,
      permission: (state) => state.permission,
    }),
    filteredSidebar() {
      return this.menuItems.filter(
        (val) => val.permission_name in this.permission.main_menu
      );
    },
  },
};
</script>
